import OverTime from '@/types/OverTime';
import Dashboard from '@/lang/ja/dashboard';
import FirmwareList from '@/lang/ja/firmwareList';
import DeviceFirmware from '@/lang/ja/deviceFirmware';
import FirmwareBulkUpdate from '@/lang/ja/firmwareBulkUpdate';
import DailyReport from '@/lang/ja/dailyReport';
import DailyReportLayout from '@/lang/ja/dailyReportLayout';
import UnexpectedEventAndAlertStatuses from '@/lang/ja/unexpectedEventAndAlertStatus';
import Every24HoursReport from '@/lang/ja/every24hoursReport';
import MonthlyReport from '@/lang/ja/monthlyReport';
import MonthlyReportWorkingTimesSetting from '@/lang/ja/monthlyReportWorkingTimesSetting';
import TemperatureSensor from '@/lang/ja/temperatureSensor';
import SafeDrivingReport from '@/lang/ja/safeDrivingReport';
import Account from '@/lang/ja/account';
import TenkoAssociation from "@/lang/ja/tenko_association";
import Vehicle from '@/lang/ja/vehicle';
import Device from '@/lang/ja/device';
import SubManagementOffice from '@/lang/ja/subManagementOffice';
import OperationOffice from '@/lang/ja/operationOffices';
import Spot from '@/lang/ja/spot';
import SafeDrivingSetting from '@/lang/ja/safeDrivingSetting';
import Group from '@/lang/ja/group';
import InstallationOffice from '@/lang/ja/installationOffice';
import AllowAccessOffice from '@/lang/ja/allowAccessOffice';
import Department from '@/lang/ja/department';
import UserRole from '@/lang/ja/userRole';
import RoleAssignment from '@/lang/ja/roleAssignment';
import DownloadData from '@/lang/ja/downloadData';
import CsvDataExport from '@/lang/ja/csvDataExport';
import CvrUpload from '@/lang/ja/cvr_upload';
import DataLinkage from '@/lang/ja/dataLinkage';
import Workload from '@/lang/ja/workload';
import VehicleInstall from '@/lang/ja/vehicleInstall';
import AuditLog from '@/lang/ja/auditLog';
import GpsTrackerSetting from '@/lang/ja/gpsTrackerSetting';
import MileageCorrection from '@/lang/ja/mileageCorrection';
import GpsTrackerProvisioning from '@/lang/ja/gpsTrackerProvisioning';

export default {
  common: {
    loadingText: "Loading...",
    unknownErrorMessage: "不明なエラー",
    notFound: "404 Not Found",
    cancelBtn: "キャンセル",
    confirmBtn: "確認",
    saveBtn: "保存",
    deleteBtn: "削除",
    selectBtn: "選択",
    backBtn: "戻る",
    confirmationModal: {
      title: '確認',
      confirmDelete: "削除してもよろしいですか？",
    },
    closeBtn: "閉じる",
    downloadBtn: "ダウンロード",
    downloadingBtn: "ダウンロード中...",
    previewBtn: "プレビュー",
    invalidURL: "不正なURLです。",
    notApplicable: 'N/A',
  },
  sideMenue: {
    dashboard: "ダッシュボード",
    firmware: {
      firmware: "ファームウェア",
      firmwareList: "ファームウェア一覧",
      FirmwareUpdate: "アップデート設定",
      FirmwareBulkUpdateList: "一括アップデート",
    },
    dailyReport: {
      dailyReport: "日報",
      dailyReportOutput: "日報出力",
      dailyReportLayout: "日報プリセット",
      UnexpectedEventAndAlertStatuseList: "特例適用",
      mileageCorrection: "走行距離修正",
    },
    every24HoursReport: "24時間毎データ",
    monthryReport: "月報",
    TemperatureSensor: {
      title: "温度管理",
      TemperatureSensor: "温度管理グラフ",
      TemperaturInformationNumerical: "温度情報数値確認",
    },
    safeDrivingReport: "安全運転帳票",
    cvr: "ドラレコ映像取得",
    settings: {
      title: "各種設定",
      accountSettings:"アカウント設定",
      account: "アカウント",
      roleAssaignment: "権限付与",
      userRoles: "権限管理",
      tenkoAssociation: "IT点呼データ連携",
      vehicle: "車両設定",
      device: "デバイス管理",
      gpsTrackerProvisioning: "GPS Tracker プロビジョニング",
      gpsTrackerSetting: "GPS Tracker設定",
      subManagementOffice: "準管理会社",
      operationOffice: "運営会社",
      spot: "地点登録",
      drivingScore: "運転スコア",
      group: "グループ",
      installationOffice: "設置会社",
      allowAccessOffice: "運営会社参照許可",
      department: "組織",
    },
    downloadData: {
      downloadData: "データ出力",
      csvDataExport: "CSV出力",
      downloadDataList: "他社連携用CSV出力",
      downloadDataHistory: "出力履歴",
    },
    dataLinkage: "データ連携",
    auditLog: "操作ログ",
    trackingService: "動態管理サービス",
    support: "サポート",
    tooltips: {
      dailyReport: {
        dailyReportOutput: "日報出力・編集",
        dailyReportLayout: "日報プリセットの作成・編集",
        UnexpectedEventAndAlertStatuseList: "連続運転時間特別延長、予期し得ない事象への対応時間の登録・編集",
        mileageCorrection: "走行距離の修正",
      },
      every24HoursReport: "速度・距離・回転数をチャートで確認",
      monthryReport: "月報出力",
      TemperatureSensor: {
        TemperatureSensor: "温度管理グラフの確認・出力",
        TemperaturInformationNumerical: "リアルタイム温度情報の確認",
      },
      safeDrivingReport: "安全運転帳票の出力",
      cvr: "ドラレコ映像の取得",
      settings: {
        account: "管理者、ドライバーの登録・編集",
        roleAssaignment: "アカウントへの権限付与",
        userRoles: "アカウント権限の作成・編集",
        tenkoAssociation: "IT点呼ドライバー連携設定",
        vehicle: "車両設定の変更",
        device: "デバイス登録・編集",
        gpsTrackerProvisioning: "GPS Trackerデバイスのプロビジョニング実行・状態確認",
        gpsTrackerSetting: "GPS Tracker設定の登録・編集",
        operationOffice: "会社内の共通設定",
        spot: "地点の登録・編集",
        drivingScore: "運転スコアの設定",
        group: "ドライバー・車両のグループ設定",
        installationOffice: "設置会社の登録・編集",
        allowAccessOffice: "動態管理閲覧許可設定",
        department: "アカウント・車両に紐付ける組織の設定",
      },
      downloadData: {
        downloadDataList: "連携データの一括出力",
        downloadDataHistory: "一括出力履歴の確認",
      },
      csvDataExport: "汎用データの出力",
      auditLog: "操作ログ",
      dataLinkage: "1日分の運行データの一括出力",
    }
  },
  pages: {
    dashboard: Dashboard,
    firmwareList: FirmwareList,
    deviceFirmware: DeviceFirmware,
    firmwareBulkUpdate: FirmwareBulkUpdate,
    dailyReports: DailyReport,
    dailyReportLayout: DailyReportLayout,
    unexpectedEventAndAlertStatuses: UnexpectedEventAndAlertStatuses,
    monthlyReport: MonthlyReport,
    monthlyReportWorkingTimesSetting: MonthlyReportWorkingTimesSetting,
    every24HoursReport: Every24HoursReport,
    temperatureSensors: TemperatureSensor,
    safeDrivingReports: SafeDrivingReport,
    accounts: Account,
    tenkoAssociation: TenkoAssociation,
    vehicles: Vehicle,
    devices: Device,
    gpsTrackerProvisioning: GpsTrackerProvisioning,
    subManagementOffice: SubManagementOffice,
    operationOffices: OperationOffice,
    spot: Spot,
    safeDrivingSetting: SafeDrivingSetting,
    groups: Group,
    installationOffices: InstallationOffice,
    allowAccessOffice: AllowAccessOffice,
    departments: Department,
    userRoles: UserRole,
    roleAssignment: RoleAssignment,
    downloadData: DownloadData,
    csvDataExport: CsvDataExport,
    cvr_uploads: CvrUpload,
    dataLinkage: DataLinkage,
    workload: Workload,
    vehicleInstall: VehicleInstall,
    auditLog: AuditLog,
    gpsTrackerSetting: GpsTrackerSetting,
    mileageCorrection: MileageCorrection,
    mainTemplate: {
      selectRole: "組織選択",
      logoutBtn: "サインアウト",
      reloadDialog: {
        title: "再ロード",
        message: "ログイン情報が変更されています。[再ロード]を押して、画面を再ロードしてください",
        closeButton: "再ロード",
      },
    },
    common: {
      resizeHandle: "ドラッグして高さを変更",
      list: {
        reading: "読み込み中",
        noData: "表にデータがありません。",
        runFilter: "フィルターを実行してください。",
        initialMessage: "最新3日間を表示しています",
        initialMessageTwoDays: "最新2日間を表示しています"
      },
      button: {
        exec: "実行",
        loading: "実行中...",
        reset: "リセット",
        close: "閉じる",
        newCreate: "新規作成",
        conservation: "保存",
        return: "戻る",
        allSelect: "全て選択",
        clear: "クリア",
        displayReload: "画面更新",
        csvExport: "CSV出力",
        csvImport: "CSV入力",
        csvUpsert: "CSV一括更新",
        csvUpsertExport: "CSV一括更新出力",
        csvUpsertImport: "CSV一括更新入力",
        search: "検索",
        import: "入力",
        sampleCsvFileDownload: "CSVサンプルをダウンロード",
      },
      messages: {
        changeStatusSuccess: "ステータスの保存に成功しました。",
        changeStatusFail: "ステータスの保存に失敗しました。",
        forbidden: "権限がありません。",
        notEditAuthority: "編集権限がありません。",
        success: "保存に成功しました。",
        failed: "保存に失敗しました。",
        successUpdate: "更新に成功しました。",
        failedUpdate: "更新に失敗しました。",
        successDelete: "削除に成功しました。",
        failedDelete: "削除に失敗しました。",
        removeSuccess: "削除に成功しました。",
        csvUpsertModalMessage: "ファイルを選択してください。「CSV一括更新出力」でダウンロードしたファイルを編集して、こちらからアップロードします。",
        failedRemove: "削除に失敗しました。",
      },
      flashMessages: {
        prefix: "詳細は",
        linkTitle: "こちら",
        suffix: "をご確認ください。",
      },
      notes: {
        csvImportFormat: "データ入力を正しく処理するために、データを正しいフォーマットで入力してください。"
      },
      labels: {
        inputFile: "入力ファイル"
      },
      help: {
        title: "ヘルプ",
      },
      sortType: {
        asc: "ASC",
        desc: "DESC",
      },
      filter: {
        title: "フィルター",
        status: {
          title: "ステータス",
          all: "全て",
          onlyActive: "有効のみ",
        },
        leaving: "出庫日",
        returning: "帰庫日",
        startTime: "開始日時",
        endTime: "終了日時",
        errorMssages: {
          pleaseSelect: "選択してください。",
          pleaseSelectCorrectRange: "範囲を正しく指定してください。",
          range: "範囲は",
          pleaseSelectWithinDays: "日間以内で指定してください。",
        },
        organization: "所属組織",
      },
      datePicker: {
        select: "選択",
        cancel: "キャンセル",
        time: "時",
        minute: "分",
      },
      autocomplete: {
        department: "組織",
        passenger: "同乗者",
        deviceType: "対応型番",
      },
      weeks: {
        Sun: "日",
        Mon: "月",
        Tue: "火",
        Wed: "水",
        Thu: "木",
        Fri: "金",
        Sat: "土",
      }
    },
    selectRole: {
      selectRoleLabel: '組織を選択'
    }
  },
  dashboard: {

  }
}
